import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import {isPlayerOnPosition} from 'helpers/player-helper';

class Validator extends BaseValidator {
    protected runValidation(): void {
        this.validatePositions();
        if (!this.hasErrors()) {
            this.validatePlayersQuantity();
        }
    }

    private validatePositions(): void {
        // @ts-ignore
        const {projectedOwnershipForce, sportConfig} = this.dependencies;
        const positions = Object.values(sportConfig.getPositions());
        const ignoredPositions = projectedOwnershipForce.getIgnoredPositions();

        if (positions.length <= ignoredPositions.length) {
            this.addError('Please, select at least one position.');
        }
    }

    private validatePlayersQuantity(): void {
        // @ts-ignore
        const {projectedOwnershipForce} = this.dependencies;

        const playersQuantity = projectedOwnershipForce.getPlayersQuantity();
        const availablePlayersQuantity = this.countAvailablePlayers();

        if (availablePlayersQuantity < playersQuantity) {
            const subValue = projectedOwnershipForce.getSubValue();
            this.addError(
                `Not enough players in your player pool to fit the rule where Projected Ownership should be less than ${subValue}%.`,
            );
        }
    }

    private countAvailablePlayers(): number {
        // @ts-ignore
        const {projectedOwnershipForce, players, sportConfig} = this.dependencies;
        const positions = Object.values(sportConfig.getPositions());
        const subValue = projectedOwnershipForce.getSubValue();
        const availablePositions = arrayDiff(positions, projectedOwnershipForce.getIgnoredPositions());

        const availablePlayers = [];
        Object.values(players).map((player) => {
            // @ts-ignore
            if (player.projOwn.getValue() <= subValue && isPlayerOnPosition(player, availablePositions)) {
                // @ts-ignore
                availablePlayers.push(player);
            }
        });

        return availablePlayers.length;
    }
}

export default Validator;
